import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/recursos/caso-petwell-migracion-magento-shopify-plus")({
  beforeLoad: () => {
    throw redirect({ to: "/es/recursos/caso-petwell-migracion-magento", statusCode: 301 });
  },
});
